module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" preserveAspectRatio=\"xMaxYMax meet\"><path fill=\"#A2B0D5\" fill-rule=\"evenodd\" d=\"M7 7.9l5.46 5.47a.64.64 0 1 0 .9-.9L7.92 6.99l5.46-5.46a.64.64 0 0 0 0-.9.64.64 0 0 0-.91 0L7 6.08 1.54.63a.64.64 0 0 0-.9 0 .64.64 0 0 0 0 .91L6.08 7 .63 12.46a.64.64 0 0 0 0 .9c.26.26.66.26.91 0L7 7.92z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/close.svg
// module id = U4zc
// module chunks = 5